var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"recoveryPassword","login-screen":""}},[_c('recoveryPassword')],1)}
var staticRenderFns = []

export { render, staticRenderFns }